import { commonEnvironment } from './environment.common';
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  common: commonEnvironment,
  socket_server_url: "https://dev.wss.oms.enelxproduct.com",
  auth_api_url: "https://dev.api.oms.enelxproduct.com/auth/",
  menu_api_url: "https://dev.api.oms.enelxproduct.com/util/metadata/main-menu",
  grid_metadata_url:
    "https://dev.api.oms.enelxproduct.com/util/metadata/admin-offer-grid",
  grid_data_url: "https://dev.api.oms.enelxproduct.com/offers/v1",
  notification_url: "https://dev.api.oms.enelxproduct.com/send/econ-clear", // TODO add correct URL
  bid_period_url: "https://dev.api.oms.enelxproduct.com/bidperiod", // TODO add correct URL -                                      //not used?
  create_offer_url: "https://dev.api.oms.enelxproduct.com/read/bidding-file",
  current_date_url: "https://dev.api.oms.enelxproduct.com/util/current-date",
  offer_summary_url: "https://dev.api.oms.enelxproduct.com/read/clearance-file",
  meter_usage_url: "https://dev.api.oms.enelxproduct.com/meter/usage",
  equipment_url: "https://dev.api.oms.enelxproduct.com/info/equipment",
  offer_equipment_url:
    "https://dev.api.oms.enelxproduct.com/offers/equipment/v1",
  offer_equipment_cbl_url:
    "https://dev.api.oms.enelxproduct.com/offers/equipment/cbl/v1",
  contact_url: "https://dev.api.oms.enelxproduct.com/notification/contacts/v1",
  no_cleared_offer_url:
    "https://dev.api.oms.enelxproduct.com/offers/no-cleared-offer",
  program_price_url:
    "https://dev.api.oms.enelxproduct.com/util/parameters/price",
  program_metadata_api_url:
    "https://dev.api.oms.enelxproduct.com/util/metadata/",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts